module.exports = __webpack_public_path__ + "images/cam4-aholic-c0f4c5305d2b34a3f4c93e7cd3ba59d1.png";